import React from 'react'
import CalenderBox from './CalenderBox'
import TicketInfo from './TicketInfo'

const Virtual = () => {
  return (
    <>
     <TicketInfo />
    </>
  )
}

export default Virtual